const URL_PROTOCOL_REGEX = /^https?:\/\//i;

export function validatePortalUrl(rawValue) {
  const trimmed = rawValue?.trim() || '';

  if (!trimmed) {
    return {
      valid: false,
      error: 'URL is required.'
    };
  }

  const candidate = URL_PROTOCOL_REGEX.test(trimmed) ? trimmed : `https://${trimmed}`;

  try {
    const parsed = new URL(candidate);

    if (!['http:', 'https:'].includes(parsed.protocol)) {
      return {
        valid: false,
        error: 'URL must start with http:// or https://.'
      };
    }

    if (!parsed.hostname || !parsed.hostname.includes('.')) {
      return {
        valid: false,
        error: 'URL must include a valid domain (e.g. example.com).'
      };
    }

    return {
      valid: true,
      normalizedUrl: candidate
    };
  } catch {
    return {
      valid: false,
      error: 'Please enter a valid URL.'
    };
  }
}

